/** URL tabs of the connector detail page; `settings` is the default and omits `?tab`. */
export const CONNECTOR_TABS = ['settings', 'transform', 'links', 'monitor'] as const;

export type ConnectorTab = (typeof CONNECTOR_TABS)[number];

/** The tabs of the editor pane; `monitor` is a pane of its own on a wide screen. */
export const EDITOR_TABS = ['settings', 'transform', 'links'] as const;

/** URL parameter naming the plugin setting the settings tab focuses once, then drops. */
export const CONNECTOR_FIELD_PARAM = 'field';

export function isConnectorTab(value: string | null | undefined): value is ConnectorTab {
  return CONNECTOR_TABS.includes(value as ConnectorTab);
}
